<label
  *ngIf="
    fieldConfig.fieldType !== 'recaptcha' &&
      fieldConfig.fieldType !== 'checkbox' &&
      fieldConfig.fieldType !== 'radio' &&
      fieldConfig.fieldType !== 'filedrop' &&
      fieldConfig.fieldType !== 'quantity';
    else withoutMainLabel
  "
  class="eb-form__field"
  [class]="
    'eb-form__field--' +
    toDashedString(fieldConfig.name) +
    ' eb-form__field--' +
    toDashedString(fieldConfig.fieldType ?? 'input') +
    (fieldConfig.required ? ' eb-form-field--required' : '') +
    (disabled ? ' eb-form-field--disabled' : '') +
    (fieldConfig.readonly ? ' eb-form-field--readonly' : '')
  "
  [attr.data-cy]="toCamelCasePath(path)"
>
  <ng-template
    [ngTemplateOutlet]="mainLabelContent"
    [ngTemplateOutletContext]="{ fieldConfig: fieldConfig }"
  ></ng-template>
  <input
    *ngIf="fieldConfig.fieldType === 'input'"
    type="text"
    [formControl]="control"
    [placeholder]="
      fieldConfig.placeholder
        ? (resolveLocalizedString(fieldConfig.placeholder) | async)
        : (createI18nToken(fieldConfig.placeholderToken || 'placeholder') | cxTranslate)
    "
    (change)="onChange($event)"
    (select)="onRefreshInputFields()"
    (keydown)="onChanging($event, true)"
    [attr.error]="error"
    [attr.disabled]="disabled || undefined"
    [attr.readonly]="fieldConfig.readonly || undefined"
  />
  <input
    #inputFile
    *ngIf="fieldConfig.fieldType === 'file'"
    type="file"
    [placeholder]="
      fieldConfig.placeholder
        ? (resolveLocalizedString(fieldConfig.placeholder) | async)
        : (createI18nToken(fieldConfig.placeholderToken || 'placeholder') | cxTranslate)
    "
    (change)="onFileChange($event)"
    [attr.error]="error"
    [attr.disabled]="disabled || undefined"
    [attr.readonly]="fieldConfig.readonly || undefined"
  />
  <select
    *ngIf="fieldConfig.fieldType === 'select'"
    [formControl]="control"
    (change)="onChange($event)"
    (keydown)="onChanging($event)"
    [attr.error]="error"
    [attr.disabled]="disabled || undefined"
  >
    <option
      *ngFor="let option of selectOptions"
      [value]="option.name"
      [attr.disabled]="
        (fieldConfig.readonly && this.control.value !== option.name) ||
        option.name === '' ||
        undefined
      "
      [attr.hidden]="option.name === '' || undefined"
    >
      {{
        option.label
          ? (resolveLocalizedString(option.label) | async)
          : (createI18nToken(option.labelToken || option.name, 'option.') | cxTranslate)
      }}
    </option>
  </select>
  <eb-datalist
    *ngIf="fieldConfig.fieldType === 'datalist'"
    [formControl]="control"
    (change)="onChange($event)"
    (keydown)="onChanging($event)"
    [placeholder]="
      fieldConfig.placeholder
        ? (resolveLocalizedString(fieldConfig.placeholder) | async)
        : (createI18nToken(fieldConfig.placeholderToken || 'placeholder') | cxTranslate)
    "
    [error]="error"
    [attr.disabled]="disabled"
    [readonly]="fieldConfig.readonly"
  >
    <option
      *ngFor="let option of fieldConfig.options"
      [value]="option.name"
      [attr.disabled]="(fieldConfig.readonly && this.control.value !== option.name) || undefined"
    >
      {{
        option.label
          ? (resolveLocalizedString(option.label) | async)
          : (createI18nToken(option.labelToken || option.name, 'option.') | cxTranslate)
      }}
    </option>
  </eb-datalist>
  <textarea
    *ngIf="fieldConfig.fieldType === 'textarea'"
    [formControl]="control"
    [value]="fieldConfig.value || ''"
    (change)="onChange($event)"
    (keydown)="onChanging($event)"
    [attr.error]="error"
    [attr.disabled]="disabled || undefined"
    [attr.readonly]="fieldConfig.readonly || undefined"
  >
  </textarea>
</label>

<ng-template #withoutMainLabel>
  <div
    class="eb-form__field"
    [class]="
      'eb-form__field--' +
      toDashedString(fieldConfig.name) +
      ' eb-form__field--' +
      toDashedString(fieldConfig.fieldType ?? 'input') +
      (fieldConfig.required ? ' eb-form__field--required' : '') +
      (disabled ? ' eb-form-field--disabled' : '') +
      (readonly ? ' eb-form-field--readonly' : '')
    "
    [attr.data-cy]="toCamelCasePath(path)"
  >
    <ng-template
      [ngTemplateOutlet]="mainLabelContent"
      [ngTemplateOutletContext]="{ fieldConfig: fieldConfig }"
    ></ng-template>
    <eb-item-counter
      *ngIf="fieldConfig.fieldType === 'quantity'"
      [control]="control"
      (change)="onChange($event)"
      (keydown)="onChanging($event)"
      [readonly]="disabled || fieldConfig.readonly"
      [pushMatomoEvents]="false"
    ></eb-item-counter>
    <ng-container *ngIf="fieldConfig.fieldType === 'recaptcha'">
      <span *ngIf="!showRecaptcha" class="eb-form-field__recaptcha" (click)="loadRecaptcha()">
        <input
          [name]="fieldConfig.name"
          type="checkbox"
          value="1"
          [checked]="isRecaptchaChecked()"
          [attr.error]="error"
          [attr.disabled]="disabled || fieldConfig.readonly || undefined"
        />
        <span>
          {{ i18nPrefix + 'recaptcha.label' | cxTranslate }}
        </span>
      </span>
      <re-captcha
        *ngIf="showRecaptcha"
        (resolved)="recaptchaResolved($event)"
        [siteKey]="fieldConfig.meta.siteKey"
      ></re-captcha>
    </ng-container>
    <ng-container *ngIf="fieldConfig.fieldType === 'checkbox' || fieldConfig.fieldType === 'radio'">
      <label *ngFor="let option of fieldConfig.options" class="eb-form-field__tickable">
        <input
          [name]="fieldConfig.name"
          [type]="fieldConfig.fieldType"
          [value]="option.name"
          (keydown)="onChanging($event)"
          (change)="onChange($event)"
          [checked]="isTickableChecked(option.name)"
          [attr.error]="error"
          [attr.disabled]="disabled || fieldConfig.readonly || undefined"
        />
        <span>
          {{
            option.label
              ? (resolveLocalizedString(option.label) | async)
              : (createI18nToken(option.labelToken || option.name, 'option.') | cxTranslate)
          }}
        </span>
      </label>
    </ng-container>
    <ng-container *ngIf="fieldConfig.fieldType === 'filedrop'">
      <label class="eb-form__file-drop-label">
        <ngx-file-drop
          (onFileDrop)="onFileDropChange($event)"
          [attr.error]="error"
          [disabled]="disabled || fieldConfig.readonly"
          [multiple]="this.fieldConfig.multiple"
          [browseBtnLabel]="i18nPrefix + 'browseBtnLabel' | cxTranslate"
          [dropZoneLabel]="i18nPrefix + 'dropZoneLabel' | cxTranslate"
          [accept]="this.fieldConfig.meta?.accept || undefined"
          [directory]="false"
          dropZoneClassName="eb-form__file-drop-zone"
          contentClassName="eb-form__file-drop-content"
        ></ngx-file-drop>
      </label>
      <div class="eb-form__file-list">
        <ul>
          <li *ngIf="!droppedFiles.length">{{ i18nPrefix + 'empty' | cxTranslate }}</li>
          <li *ngFor="let droppedFile of droppedFiles; let i = index">
            <div class="eb-form__dropped-file">
              <span>{{ droppedFile.relativePath }}</span>
              <button (click)="removeDroppedFile($event, i)">
                <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
              </button>
            </div>
          </li>
        </ul>
        <p class="eb-form__file-hint">
          {{ i18nPrefix + 'hint' | cxTranslate }}
        </p>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #mainLabelContent let-fieldConfig="fieldConfig">
  <span class="eb-form__field-label-content" *ngIf="!fieldConfig.hideTitle">
    {{
      fieldConfig.title
        ? (resolveLocalizedString(fieldConfig.title) | async)
        : (createI18nToken(fieldConfig.titleToken || 'header') | cxTranslate)
    }}
  </span>
</ng-template>
